import { useState } from "react";
import { fetchPatientBills } from "../../utils/patients/fetchPatientsBills";
import { fetchLabRequests } from "../../utils/patients/fetchlabrequests";
import useProfileStore from "../../store/patient/profileStore";
import { fetchLabRequestsAlt } from "../../utils/patients/fetchLabrequestAlt";
import { fetchGroupedTest } from "../../utils/patients/fetchGroupedTest";
import { QueryLabRequest } from "../../utils/patients/querryLabTest";
import { fetchAlltTest } from "../../utils/patients/fetchAllTest";
import { sendLabRequest } from "../../utils/patients/createLabRequest";
import { fetchPurchasedDrugs } from "../../utils/patients/fetchPurchasedDrugs";

const useManageLabRequests = () => {

  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState()
  const {profile} = useProfileStore()
  const [groupTest, setGroupedTest] = useState([])
  const [labs, setLabs] = useState([]);
  const [purchasedDrugs, setPurchasedDrugs] = useState([]);

  

  // id = 27503
  const handleFechLabRequests = async () => {
    setLoading(true);
    await fetchLabRequests(profile?.id)
    .then((res) => {
        setLoading(false);
        setRequests(res?.data?.result)
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleFechLabRequestsAlt = async () => {
    setLoading(true);
    await fetchLabRequestsAlt(profile?.id)
    .then((res) => {
        setLoading(false);
        setRequests(res?.data?.result)
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
      });
  };

  const handleFechGroupedTest = async () => {
    setLoading(true);
    await fetchGroupedTest(profile?.id)
    .then((res) => {
        setLoading(false);
        // setRequests(res?.data?.result)
        setGroupedTest(res?.data)
      })
      .catch((err) => {
        setLoading(false);
      });
  };

const handleFechAllTest = async () => {
    setLoading(true);
    await fetchAlltTest(profile?.id)
    .then((res) => {
        setLoading(false);
        setLabs(res?.data)
        // setRequests(res?.data?.result)
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
        localStorage?.setItem("user", null)
      });
  };

  const handleQueryTest = async (data, prof) => {
    setLoading(true);
    await QueryLabRequest(data, prof)
    .then((res) => {
        setLoading(false);
        // setRequests(res?.data?.result)
        setLabs(res?.data)
      })
      .catch((err) => {
        setLoading(false);
      });
  };

    const handleSubmitRequest = async (id,request_type, payload, note) => {
      setLoading(true);
      try{
          const response = await sendLabRequest(id,request_type, payload, note)
          return response
    
      } catch(err) {
        console.log(err)
        window.location.href = "/pages/signin2";
        console.log("error error");
        localStorage?.setItem("user", null)


      } finally {
        setLoading(false)
      }
    };

       // id = 27503
  const handleFetchPurchasedDrugs = async (request_type) => {
    setLoading(true);
    await fetchPurchasedDrugs(profile?.id, request_type)
    .then((res) => {
        setLoading(false);
        setPurchasedDrugs(res?.data?.result)
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return {
    handleFechLabRequests,
    requests,
    handleFechAllTest,
    handleFechGroupedTest,
    handleQueryTest,
    loading,
    handleSubmitRequest,
    handleFechLabRequestsAlt,
    handleFetchPurchasedDrugs,
    purchasedDrugs,
    labs,
    groupTest,
  };
};

export default useManageLabRequests;